"use strict";

exports.__esModule = true;
exports.default = void 0;

var _carousel = require("./carousel");

var _carouselSlide = require("./carousel-slide");

var _plugins = require("../../utils/plugins");

var components = {
  BCarousel: _carousel.default,
  BCarouselSlide: _carouselSlide.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/carousel/index.js
// module id = 435
// module chunks = 0